
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/resources/performance",
      function () {
        return require("private-next-pages/x/react-chat/resources/performance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/resources/performance"])
      });
    }
  